import axios from "axios";
import { config } from "../config/config";
const useFetch = axios.create({
  baseURL: config.BASE_URL,
});
useFetch.interceptors.request.use(
  (config) => {
    if (config.url) {
      config.url = config.baseURL + config.url;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export { useFetch };
